import { PreferencesCard } from "@/components/account/PreferencesCard";
import { PrivacyCard, SecurityCard } from "@/components/account/PrivacySecurity";
import { SubscriptionCard } from "@/components/account/SubscriptionCard";
import { useI18n } from "@/i18n";
import { getSessionUser, signOutAccount } from "@/lib/mockAuth";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { Button } from "@/components/ax/Button";
import styles from "@/components/account/AccountVisual.module.css";
import { ProfilePhoto } from "@/components/account/ProfilePhoto";

export default function Akun() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [signingOut, setSigningOut] = useState(false);
  const out = async () => {
    if (signingOut) return;
    setSigningOut(true);
    await signOutAccount();
    navigate("/masuk", { replace: true });
  };
  const user = getSessionUser();
  const initials = (user.name || user.email || "AX").trim().split(/\s+/).slice(0, 2).map((part) => Array.from(part)[0]).join("").toUpperCase();
  return (
    <div data-testid="account-page" className={styles.page}>
      <p className={styles.eyebrow}>{t("acc.workspaceTitle")}</p>
      <p className={styles.lede}>{t("acc.lede")}</p>
      <section className={styles.profile} aria-labelledby="account-name" data-testid="account-profile">
        <ProfilePhoto initials={initials} />
        <div className={styles.identity}>
          <h1 id="account-name" className={styles.title} data-testid="account-title">{user.name || t("nav.account")}</h1>
          {user.email && <p className={styles.email} data-testid="account-email">{user.email}</p>}
        </div>
      </section>
      <div className={styles.cards}>
        <PreferencesCard />
        <SubscriptionCard />
        <PrivacyCard />
        <SecurityCard />
      </div>
      <div className={styles.logout}>
        <Button variant="ghost" onClick={out} disabled={signingOut} busy={signingOut} data-testid="logout-button">
          <LogOut size={16} strokeWidth={1.5} aria-hidden="true" />
          {signingOut ? t("acc.signingOut") : t("acc.signout")}
        </Button>
      </div>
    </div>
  );
}
